<template>
    <div class="loading">
        <img src="../assets/images/load.gif" alt="360 Agency">
    </div>
</template>

<script>
import $ from 'jquery'
import { setTimeout } from 'timers';
export default {
    name: 'Loading',
    data() {
        return {
            load: 0,
        }
    },
    mounted() {
        $(window).on('load', function () {
            setTimeout(() => {
                $('.loading').addClass('fadeOut animated');
                setTimeout(() => {
                    $('.loading').hide();
                }, 500)
            }, 2500);
        });
    },
    watch:{
        $route(){
            if(this.load > 0){
                $('.loading').removeClass('fadeOut animated').show();
                
                setTimeout(() => {
                    $('.loading').addClass('fadeOut animated');
                    setTimeout(() => {
                        $('.loading').hide();
                    }, 500)
                }, 2500);
            }
            this.load ++;
        }
    } 
}
</script>